var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 2.83333C0 1.54635 1.29549 0.5 2.88889 0.5H14.4444C16.0378 0.5 17.3333 1.54635 17.3333 2.83333V12.1667C17.3333 13.4536 16.0378 14.5 14.4444 14.5H2.88889C1.29549 14.5 0 13.4536 0 12.1667V2.83333ZM25.2372 1.80521C25.7066 2.00938 26 2.40312 26 2.83333V12.1667C26 12.5969 25.7066 12.9906 25.2372 13.1948C24.7677 13.399 24.199 13.3771 23.7521 13.1365L19.4188 10.8031L18.7778 10.4568V9.83333V5.16667V4.54323L19.4188 4.19687L23.7521 1.86354C24.1944 1.62656 24.7632 1.60104 25.2372 1.80521Z",
    fill: "#FFB399"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video-icon.fe7ffa43826364d7aff91f94e0d325f3.svg";
export { ForwardRef as ReactComponent };